import projectOptions from "src/shared/project-options";
import getEnabledVariants, { EnabledVariants } from "./get-enabled-variants";

interface ReturnProductModalAttributes {
  image: string;
  name: string;
  price: string;
  pk: string;
  enabledVariants: EnabledVariants;
  shouldShowModal: boolean;
  productDiscount?: string;
}

const productImageIndex = projectOptions.default.style.product.productImage;

const getProductModalAttributes = (
  variantsData: any,
  productSummary: any,
  isVisible: boolean
): ReturnProductModalAttributes => {
  const { image } =
    variantsData?.product?.productimageSet?.[productImageIndex] ??
    productSummary ??
    {};
  const { name, price, pk, productDiscount } =
    variantsData?.product ?? productSummary ?? {};
  const enabledVariants = getEnabledVariants(variantsData?.variants);
  const shouldShowModal = isVisible && productSummary;

  return {
    image,
    name,
    price,
    pk,
    productDiscount,
    enabledVariants,
    shouldShowModal,
  };
};

export default getProductModalAttributes;
